
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lawyers/states/[state]",
      function () {
        return require("private-next-pages/lawyers/states/[state].tsx");
      }
    ]);
  